<template>
  <div style="margin: 0 auto; height: 500px; padding-top: 200px">
    <v-text-field
      density="compact"
      label="Company Name"
      variant="outlined"
      v-model="companName"
      placeholder="NMG Technologies"
    >
    </v-text-field>
    <v-btn @click="awsapi">Continue with SSO</v-btn>
  </div>
</template>
<script setup>
import { ref, watchEffect } from "vue";
import axios from "axios";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const newCode = ref();
const store = useStore();
const router = useRouter();
const companName = ref("NMG Technologies");
watchEffect(() => {
  let uri = window.location.search;
  // console.log(uri);
  const value = uri.split("=")[1];
  // console.log(value);
  newCode.value = value;
  if (newCode.value) {
    tokenapi();
  }
});
function awsapi() {
  window.open(
    "https://competiscan-uat-auth.auth.us-west-2.amazoncognito.com/login?response_type=code&client_id=7lihvlaru5dt9qvc56h4mjhrf2&redirect_uri=https://cp.dev.competiscan.com/",
    "_self"
  );
}

function tokenapi() {
  console.log(newCode.value, " new");
  axios
    .post(
      `https://competiscan-uat-auth.auth.us-west-2.amazoncognito.com/oauth2/token`,
      null,
      {
        params: {
          grant_type: "authorization_code",

          client_id: "7lihvlaru5dt9qvc56h4mjhrf2",

          client_secret: "sbmj3fh8th3h6bde99kngf62jm0fuscaactr4jh3snmeubvdi1s",

          code: newCode.value,

          redirect_uri: "https://cp.dev.competiscan.com/",
        },
      }
    )
    .then((response) => {
      // const newAccessToken = response.data.access_token;
      // console.log(response);
      localStorage.setItem(
        "access_token",
        JSON.stringify(response.data.access_token)
      );
      localStorage.setItem("id_token", JSON.stringify(response.data.id_token));
      localStorage.setItem(
        "refresh_token",
        JSON.stringify(response.data.refresh_token)
      );
      localStorage.setItem(
        "expires_in",
        JSON.stringify(response.data.expires_in)
      );
      if (response.data.access_token)
        store.dispatch("Rawdata/setisAuthLogin", true);
      router.replace({ path: "/power-search" });
      // window.open("http://localhost:8080/", "_self");
    })
    .catch((error) => {
      console.log("Error al renovar el token de acceso", error);
    });
}
</script>
